import "./index.css";
import { useMoviesStore } from "../../stores/useMoviesStore";
import { useEffect, useRef, useCallback } from "react";
import { MovieItem } from "../../components/movie-item";
import { NoItemsFound } from "../../components/common/NoItemsFound";
import Loader from "../../components/common/Loader";
import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";

const PopularScreen = () => {
  const { popularMovies, fetchPopularMovies, hasMorePopular, isLoading } =
    useMoviesStore();

  const pageRef = useRef<number>(1);

  const fetchPopular = useCallback(() => {
    fetchPopularMovies({
      page: pageRef.current,
    });
  }, [fetchPopularMovies]);

  const loadMoreVideos = useCallback(() => {
    pageRef.current = pageRef.current + 1;
    fetchPopular();
  }, [fetchPopular]);

  useEffect(() => {
    pageRef.current = 1;
    fetchPopular();
  }, [fetchPopular]);

  const { lastElementRef } = useInfiniteScroll({
    isLoading,
    hasNextPage: hasMorePopular,
    onLoadMore: loadMoreVideos,
  });

  return (
    <div className="screen-container">
      {isLoading && popularMovies.length === 0 ? (
        <Loader />
      ) : popularMovies.length === 0 ? (
        <NoItemsFound text="No movies in Popular!" />
      ) : (
        <>
          <div className="grid-container">
            {popularMovies.map((item) => (
              <MovieItem key={item.id} movie={item} />
            ))}
          </div>
          {hasMorePopular && (
            <div ref={lastElementRef} style={{ height: "20px" }} />
          )}
        </>
      )}
      {isLoading && popularMovies.length > 0 && <Loader />}
    </div>
  );
};

export default PopularScreen;
